import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function validateThaiID(control: AbstractControl): ValidationErrors | null {
  const idNumber = control.value;
  if (!idNumber) {
    return null; // No value, no error
  }

  // Check if the ID number is exactly 13 digits long
  if (idNumber.length !== 13 || !/^\d+$/.test(idNumber)) {
    return { invalidThaiID: true };
  }

  // Calculate the checksum
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += parseInt(idNumber.charAt(i), 10) * (13 - i);
  }
  const checksum = (11 - (sum % 11)) % 10;

  // Validate the checksum against the last digit of the ID number
  if (checksum !== parseInt(idNumber.charAt(12), 10)) {
    return { invalidThaiID: true };
  }

  return null; // Valid Thai ID number
}